import React from 'react';

import { DateTime } from 'luxon';

import { DateFormatPatterns, DEFAULT_VALUE_IF_NIL } from '@clearverify/constants';

import { ActiveInactive, useStatesListQuery } from 'src/api';
import { buildCreatedAtBeforeDateFilter, getLatestDate } from 'src/utils/dashboard';

import { useDashboardCVAdminData } from './useDashboardCVAdminData';

export const useOverviewDataPrivacyStates = () => {
  const { date } = useDashboardCVAdminData();

  const { data, loading } = useStatesListQuery({
    variables: {
      filter: {
        ...buildCreatedAtBeforeDateFilter(date.toISO()),
        privacySetting: {
          equals: ActiveInactive.Active,
        },
      },
    },
  });

  const dataPrivacyStates = React.useMemo(
    () => (data?.stateList ?? []).toSorted((a, b) => a.name?.localeCompare(b.name || '') || 0),
    [data],
  );

  const lastUpdateDate = React.useMemo(() => {
    const updateDates = dataPrivacyStates.map(state => state.createdAt);
    const latestDate = getLatestDate(updateDates);
    if (!latestDate) return DEFAULT_VALUE_IF_NIL;
    return DateTime.fromISO(latestDate).toFormat(DateFormatPatterns.shortDateWithSlash);
  }, [dataPrivacyStates]);

  return {
    dataPrivacyStates,
    dataPrivacyStatesLoading: loading,
    lastUpdateDate,
  };
};
